import React, { useState, useEffect } from 'react'
import { Ul, Dropdown } from 'meinian-package/src/baseComponent'
import { useRequest } from 'ahooks'
import Tile from 'meinian-package/src/baseComponent/select/tile'
import { SelectDisplay } from 'meinian-package/src/baseComponent/select'
import request from 'meinian-package/src/utils/request'
import { GENDER_VALUE } from 'meinian-package/src/component/enum'
import './index.less'

const convert = (result) => {
  const all = []
  result.forEach((item) => {
    let parent = null
    parent = { label: item.name, value: item.name, node: 1 }
    let children = null
    if (item.children && item.children.length) {
      children = item.children.map(son => ({
        label: son.name,
        value: son.name,
        parent,
        node: 2
      }))
      parent.children = children
    }
    all.push(parent)
  })
  return all
}
const GENDERS = [{ label: '不限', value: undefined },
  { label: '女装', value: GENDER_VALUE.WOMEN },
  { label: '男装', value: GENDER_VALUE.MEN },
  { label: '男童', value: GENDER_VALUE.BOY },
  { label: '女童', value: GENDER_VALUE.GIRL },
  { label: '童装', value: GENDER_VALUE.CHILD },
  { label: '鞋靴', value: GENDER_VALUE.SHOES }]
export default (props) => {
  const { category, shopStatus, onChange, displayStyle, placeholder } = props
  const [visible, setVisible] = useState(false)
  const [gender, setGender] = useState(props.gender)

  useEffect(() => {
    setGender(props.gender)
  }, [props.gender])

  const fetchCategories = () => {
    return new Promise((resolve) => {
      if (!gender) {
        resolve([])
      } else {
        request.sget('/zhikuan/common/list-all-category', { gender, shopStatus }, 'MNListCategory').then(res => {
          if (res) {
            resolve(convert(res.children))
          }
        })
      }
    })
  }
  const { data, run } = useRequest(fetchCategories, {
    debounceWait: 250,
    manual: true
  })

  useEffect(() => {
    run()
  }, [gender, shopStatus])

  const onOk = (_gender, _category) => {
    setVisible(false)
    onChange && onChange(_gender, _category)
  }
  return <Dropdown
    getPopupContainer={() => document.body}
    overlayStyle={{ zIndex: 1001 }}
    overlay={<div className="meinian-select-list-cascade meinian-gender-category-select">
      <div className="left">
        <Ul
          value={gender}
          data={GENDERS}
          onMouseEnter={val => setGender(val)}
          className="left-list"
          onChange={val => onOk(val, undefined)}
        />
      </div>
      <div className="right">
        <Tile
          value={category}
          data={data}
          onChange={val => onOk(gender, val)}
          allowClear={false}
        />
      </div>
    </div>}
    visible={visible}
    onVisibleChange={_visible => setVisible(_visible)}
  >
    <span style={{ display: 'inline-block' }}>{category ? <SelectDisplay.Level
      prefix={`${props.gender}-`}
      showValueAsLabel
      value={category}
      data={data}
      visible={visible}
      allowClear
      onClear={() => onOk(undefined, undefined)}
      placeholder={placeholder || '品类'}
      displayStyle={displayStyle}
    />
      : <SelectDisplay
          value={props.gender}
          data={GENDERS}
          allowClear
          placeholder={placeholder || '品类'}
          visible={visible}
          onClear={() => onOk(undefined, undefined)}
          displayStyle={displayStyle}
      />}</span>
  </Dropdown>
}
